// raindrops (raindrops.js)
jQuery(function($) {

  var $target = $('#js-ripples');
  if ($target.length) {
    $target.ripples({
  		resolution: 500,
  		dropRadius: 40,
  		perturbance: 0.01
  	});

    // 動的なリサイズは操作後0.3秒経ってから処理を実行する。
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        $target.ripples('updateSize');
      }, 300);
    }, false);

    inView('#js-ripples').on('enter', function() {
      $target.ripples('updateSize');
    });
  }

  function resizeCanvas() {
    var $canvas = $target.find('canvas');
    var _h = $target.outerHeight();
    $canvas.attr('height', _h);
    $canvas.addClass('resizeddd');
    console.log('_h = ' + _h);
    console.log($canvas);
  }

});
